import React from 'react'
import Signupsection from '../MainSignin/Signupsection'

const main = () => {
  return (
    <div>
      <Signupsection/>
    </div>
  )
}

export default main
